import { createReducer } from '@reduxjs/toolkit'
import { DictT, TourT } from 'types/model'
import { receiveTours } from 'model/actions'

const initialState = null as DictT<TourT> | null

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveTours, (state, action) => action.payload)
})

export default reducer
